import { callAPI } from "../services/api";

export const isOktaUserFeaturesAdmin = async (username) => {
  let route = `validateUser/${username}`
  try {
    const data = await callAPI(route)
    return data.isAllowed
  } catch(error) {
    throw(error)
  }
}